
import { mapState } from "vuex";

export default {
  props: {
    isAccepted: {
      default: false
    },
    acceptanceTime: {
      default: ""
    },
    isOrderReady: {
      default: false
    },
    preparationTime: {
      default: ""
    },
    isDispatched: {
      default: false
    },
    pickedUpTime: {
      default: ""
    },
    isCompleted: {
      default: false
    },
    deliveryTime: {
      default: ""
    },
    orderTotalDuration: {
      default: ""
    },
    isTakeAwayOrder: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {}
};
